const BusinessVerifiedStatusBadge = ({ verified }: { verified: boolean }) => {

    const getTransactionColorAndName = (verified: boolean) => {
        if (verified) {
            return {
                color: '#D1FAE5',
                name: 'verified',
                text: '#065F46',
            }
        }
        return {
            color: '#FEF3C7',
            name: 'pending',
            text: '#92400E',
        }
    }

    return (
        <span style={{ backgroundColor: getTransactionColorAndName(verified).color, color: getTransactionColorAndName(verified).text }} className="rounded-full py-2 px-3 text-xs text-white">
            {getTransactionColorAndName(verified).name}
        </span>
    )
}

export {
    BusinessVerifiedStatusBadge
}